import {
  getFaultsUpload,
  getFaultById,
  getFaultUserGroups,
  postFault,
  putFault,
  deleteFault,
  patchFaultDefinition,
  postFaultDefinition,
  deleteFaultDefinition,
} from '../utils/requests/troubleshootingAPI'

export const LOAD_FAULTS_UPLOAD = 'LOAD_FAULTS_UPLOAD'
export const LOAD_FAULTS_UPLOAD_PENDING = 'LOAD_FAULTS_UPLOAD_PENDING'
export const LOAD_FAULTS_UPLOAD_FULFILLED = 'LOAD_FAULTS_UPLOAD_FULFILLED'
export const LOAD_FAULTS_UPLOAD_REJECTED = 'LOAD_FAULTS_UPLOAD_REJECTED'

export const LOAD_NEW_FAULTS_UPLOAD = 'LOAD_NEW_FAULTS_UPLOAD'
export const LOAD_NEW_FAULTS_UPLOAD_PENDING = 'LOAD_NEW_FAULTS_UPLOAD_PENDING'
export const LOAD_NEW_FAULTS_UPLOAD_FULFILLED = 'LOAD_NEW_FAULTS_UPLOAD_FULFILLED'
export const LOAD_NEW_FAULTS_UPLOAD_REJECTED = 'LOAD_NEW_FAULTS_UPLOAD_REJECTED'

export const LOAD_FAULT_DETAILS = 'LOAD_FAULT_DETAILS'
export const LOAD_FAULT_DETAILS_PENDING = 'LOAD_FAULT_DETAILS_PENDING'
export const LOAD_FAULT_DETAILS_FULFILLED = 'LOAD_FAULT_DETAILS_FULFILLED'
export const LOAD_FAULT_DETAILS_REJECTED = 'LOAD_FAULT_DETAILS_REJECTED'

export const LOAD_FAULT_USER_GROUPS = 'LOAD_FAULT_USER_GROUPS'
export const LOAD_FAULT_USER_GROUPS_PENDING = 'LOAD_FAULT_USER_GROUPS_PENDING'
export const LOAD_FAULT_USER_GROUPS_FULFILLED = 'LOAD_FAULT_USER_GROUPS_FULFILLED'
export const LOAD_FAULT_USER_GROUPS_REJECTED = 'LOAD_FAULT_USER_GROUPS_REJECTED'

export const POST_FAULT = 'POST_FAULT'
export const POST_FAULT_PENDING = 'POST_FAULT_PENDING'
export const POST_FAULT_FULFILLED = 'POST_FAULT_FULFILLED'
export const POST_FAULT_REJECTED = 'POST_FAULT_REJECTED'

export const PUT_FAULT = 'PUT_FAULT'
export const PUT_FAULT_PENDING = 'PUT_FAULT_PENDING'
export const PUT_FAULT_FULFILLED = 'PUT_FAULT_FULFILLED'
export const PUT_FAULT_REJECTED = 'PUT_FAULT_REJECTED'

export const PATCH_FAULT_DEFINITION = 'PATCH_FAULT_DEFINITION'
export const PATCH_FAULT_DEFINITION_PENDING = 'PATCH_FAULT_DEFINITION_PENDING'
export const PATCH_FAULT_DEFINITION_FULFILLED = 'PATCH_FAULT_DEFINITION_FULFILLED'
export const PATCH_FAULT_DEFINITION_REJECTED = 'PATCH_FAULT_DEFINITION_REJECTED'

export const POST_FAULT_DEFINITION = 'POST_FAULT_DEFINITION'
export const POST_FAULT_DEFINITION_PENDING = 'POST_FAULT_DEFINITION_PENDING'
export const POST_FAULT_DEFINITION_FULFILLED = 'POST_FAULT_DEFINITION_FULFILLED'
export const POST_FAULT_DEFINITION_REJECTED = 'POST_FAULT_DEFINITION_REJECTED'

export const DELETE_FAULT = 'DELETE_FAULT'
export const DELETE_FAULT_PENDING = 'DELETE_FAULT_PENDING'
export const DELETE_FAULT_FULFILLED = 'DELETE_FAULT_FULFILLED'
export const DELETE_FAULT_REJECTED = 'DELETE_FAULT_REJECTED'

export const DELETE_FAULT_DEFINITION = 'DELETE_FAULT_DEFINITION'
export const DELETE_FAULT_DEFINITION_PENDING = 'DELETE_FAULT_DEFINITION_PENDING'
export const DELETE_FAULT_DEFINITION_FULFILLED = 'DELETE_FAULT_DEFINITION_FULFILLED'
export const DELETE_FAULT_DEFINITION_REJECTED = 'DELETE_FAULT_DEFINITION_REJECTED'

export const CLEAR_FAULT_DETAILS = 'CLEAR_FAULT_DETAILS'
export const CLEAR_TROUBLESHOOTING_MESSAGES = 'CLEAR_TROUBLESHOOTING_MESSAGES'

export function loadFaultsUpload(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_FAULTS_UPLOAD : LOAD_FAULTS_UPLOAD,
    payload: getFaultsUpload(queryParams),
  }
}

export function loadFaultDetails(id) {
  return {
    type: LOAD_FAULT_DETAILS,
    payload: getFaultById(id),
  }
}

export function loadFaultUserGroups() {
  return {
    type: LOAD_FAULT_USER_GROUPS,
    payload: getFaultUserGroups(),
  }
}

export function createFault(bodyParams) {
  return {
    type: POST_FAULT,
    payload: postFault(bodyParams),
  }
}

export function updateFault(id, bodyParams) {
  return {
    type: PUT_FAULT,
    payload: putFault(id, bodyParams),
  }
}

export function updateFaultDefinition(faultId, definitionId, bodyParams) {
  return {
    type: PATCH_FAULT_DEFINITION,
    payload: patchFaultDefinition(faultId, definitionId, bodyParams),
  }
}

export function createFaultDefinition(faultId, bodyParams) {
  return {
    type: POST_FAULT_DEFINITION,
    payload: postFaultDefinition(faultId, bodyParams),
  }
}

export function removeFault(id) {
  return {
    type: DELETE_FAULT,
    payload: deleteFault(id),
    meta: { id },
  }
}

export function removeFaultDefinition(faultId, definitionId) {
  return {
    type: DELETE_FAULT_DEFINITION,
    payload: deleteFaultDefinition(faultId, definitionId),
    meta: { definitionId },
  }
}

export function clearFaultDetails() {
  return {
    type: CLEAR_FAULT_DETAILS,
  }
}

export function clearTroubleshootingMessages() {
  return {
    type: CLEAR_TROUBLESHOOTING_MESSAGES,
  }
}
